import { expectShape } from "@/lib/expect/expect-shape";
import { SESSION_FIELDS } from "@/commands/sessions/sessions-constants";
import type { SessionDetail } from "@/commands/session/session-detail";
export function detail(payload: unknown, endpoint: string): SessionDetail {
  return expectShape<SessionDetail>(payload, endpoint, SESSION_FIELDS);
}
